<template>
  
    <div class="home">
        
        <div class="home--hero">
            <div class="home--hero-wrap">
              <div class="home--hero-title">
                <div class="title-mask lvl-1"><span>PRENEZ PLACE</span></div> <div class="title-mask lvl-2"><span>ENTRE MES VISCÈRES</span></div> <div class="title-mask lvl-3"><span>LAMINÉES.</span></div>
              </div>
              <div class="home--hero-paragraphs">
                <p>Je m'évide des maux sur ce qui est à ma disposition, j'écris ce qui me vient sans me limiter.</p>
                <p>Si vous voulez en savoir plus, c'est à vous de me trouver.</p>
              </div>
            </div>
        </div>
        
        <ListPublications />
      
    </div>
  
</template>

<script>

import ListPublications from "@/components/ListPublications"

export default {
  name: "Home",
  data() {
    return {
      show: true
    }
  },
  components: {
    ListPublications
  },
  mounted() {
    window.componentInstance.setBackground('dark');
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/sass/templates/_home";
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.site--title{
  color: $brown;
  font-family: $NewEddy;
  @include font(30,40);
  font-weight: 400;
  text-transform: uppercase;
}



</style>
